import React, { useState } from "react";
import Button from "../../../../Components/Common/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCloudUploadAlt,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import useSWRMutation from "swr/mutation";
import { FileApiUrls } from "../../../../Api/Auth/ApiUrls";
import { sendPostRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../../hooks/useErrorToast";

const UploadImage = ({ onBack, folder }) => {
  const [dragging, setDragging] = useState(false);
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileType] = useState("public");
  const { showErrorToast } = useToastError();

  const { trigger, isMutating } = useSWRMutation(
    FileApiUrls.create,
    sendPostRequestAuth,
    {
      onSuccess: (data) => {
        toast.success("Success");
        onBack();
      },
      onError: (error) => {
        showErrorToast(error);
      },
    }
  );

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const files = e.dataTransfer.files?.[0];
    setFile(files);
    previewImage(files);
  };

  const handleFileChange = (e) => {
    // const files = e.target.files?.[0];
    const files = Array.from(e.target.files); // Convert FileList to array
    setFile(files);
    previewImage(files);
  };

  const previewImage = (files) => {
    const previews = [];

    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        previews.push(reader.result);

        // When all previews are ready, update state
        if (previews.length === files.length) {
          setPreviewUrl(previews); // Array of base64 previews
        }
      };

      reader.readAsDataURL(file);
    });
  };

  // const handleFileTypeChange = (e) => {
  //   const newFileType = e.target.value;
  //   setFileType(newFileType);
  // };

  const stopEventPropagation = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up to the parent
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || file.length === 0) {
      toast.error("Please select at least one file");
      return;
    }

    const formData = new FormData();

    // Loop through files and append each one
    for (let i = 0; i < file.length; i++) {
      formData.append("file", file[i]); // or use file[] if backend expects it
    }

    if (folder) formData.append("folder", folder);
    formData.append("private", fileType === "private" ? "true" : "false");

    trigger(formData);
  };

  return (
    <>
      {/* Back Button */}
      <Button onClick={onBack} size="small" className="mb-4">
        <span className="flex gap-2 items-center">
          <FontAwesomeIcon icon={faArrowLeft} />
          Back to List
        </span>
      </Button>

      {/* Upload Container */}
      <div
        className={`border-4 border-dashed p-8 rounded-lg text-center transition-all cursor-pointer ${
          dragging ? "border-primary bg-blue-100" : "border-gray-300"
        }`}
        onDragEnter={handleDragEnter} // Handle drag entering the container
        onDragOver={(e) => e.preventDefault()} // Prevent the default behavior to allow drops
        onDragLeave={handleDragLeave} // Handle drag leaving the container
        onDrop={handleDrop} // Handle the dropped files
        onClick={() => document.getElementById("fileInput").click()} // Open the file input on click
      >
        {/* Icon and Message */}
        <FontAwesomeIcon
          icon={faCloudUploadAlt}
          className="text-4xl mb-4 text-gray-500"
          onDragEnter={stopEventPropagation}
          onDragOver={stopEventPropagation}
          onDragLeave={stopEventPropagation}
        />
        <p
          className="text-lg text-gray-700"
          onDragEnter={stopEventPropagation}
          onDragOver={stopEventPropagation}
          onDragLeave={stopEventPropagation}
        >
          Drag files here to upload, or click to browse
        </p>

        {/* Hidden File Input */}
        <input
          type="file"
          id="fileInput"
          className="hidden"
          multiple
          onChange={handleFileChange}
          onDragEnter={stopEventPropagation}
          onDragOver={stopEventPropagation}
          onDragLeave={stopEventPropagation}
        />
      </div>
      <div className="flex gap-x-16 flex-wrap">
        {file &&
          file.map((item, index) => (
            <div className="mt-4 text-gray-700" key={index}>
              <p>
                <span className="font-medium">Selected file:</span> {item.name}
              </p>
              {/* Show Image Preview */}
              {previewUrl && (
                <div className="mt-4 flex gap-6">
                  {/* Image Preview Section */}
                  <div className="flex-shrink-0">
                    <img
                      src={
                        item.type.includes("video")
                          ? "/videoThumb.jpg"
                          : item.type === "application/pdf"
                          ? "https://storage.googleapis.com/road-to-fe/uploads/1741110111744-5fb0db0b-ee21-4a9e-82f4-f09d87b3bbc6-pdfIcon.png"
                          : previewUrl[index]
                      }
                      alt="Preview"
                      className="w-40 h-40 object-cover rounded-md border-2 border-gray-300"
                    />
                  </div>

                  {/* File Type Selection */}
                  {/* <div className="flex-1">
                <p>
                  <strong>File Type:</strong>
                </p>

                <div className="flex items-center gap-4 mb-3">
                  <label className="flex items-center gap-2 text-gray-700">
                    <input
                      type="radio"
                      value="public"
                      checked={fileType === "public"}
                      onChange={handleFileTypeChange}
                      className="form-radio text-blue-500"
                    />
                    <span>Public</span>
                  </label>
                  <label className="flex items-center gap-2 text-gray-700">
                    <input
                      type="radio"
                      value="private"
                      checked={fileType === "private"}
                      onChange={handleFileTypeChange}
                      className="form-radio text-blue-500"
                    />
                    <span>Private</span>
                  </label>
                </div>
                <Button
                  onClick={handleSubmit}
                  size="small"
                  className="mb-4"
                  isLoading={isMutating}
                >
                  <span className="flex gap-2 items-center">
                    <FontAwesomeIcon icon={faUpload} />
                    Submit
                  </span>
                </Button>
              </div> */}
                </div>
              )}
            </div>
          ))}
      </div>
      <Button
        onClick={handleSubmit}
        size="small"
        className="my-4"
        isLoading={isMutating}
      >
        <span className="flex gap-2 items-center">
          <FontAwesomeIcon icon={faUpload} />
          Submit
        </span>
      </Button>
    </>
  );
};

export default UploadImage;
